import axios from "axios";

export const getCcrResults = async (country_id, industry_id, gross_profit_margin, function_to_call, authHeader) => {
  const searchParams = new URLSearchParams({
    country: country_id,
    industry: industry_id,
    gross_profit_margin: gross_profit_margin,
    function_to_call: function_to_call
  });

  const url = `${process.env.REACT_APP_BASE_URL}/model/ccr?${searchParams.toString()}`
  const data = {};
  const config = {
    headers: {
      "accept": "application/json",
      "Authorization": authHeader
    },
  };

  return await axios.post(url, data, config);
}